"use client"

import { NpProductImages } from "src/components/np-design/components/product-images/NpProductImages"
import { useProductContext } from "./context"

export const ProductImages = () => {
  const { name, resolvedImages: images } = useProductContext()

  if (!images.length) {
    return null
  }

  return <NpProductImages name={name} images={images} />
}
